export default __webpack_public_path__ + "stroke.asset.ef14ac5238c1632de7fcd0a925b3e789.svg";